import styled, { createGlobalStyle } from 'styled-components';
import { Card } from '../../Card';
import { theme } from '../../../theme';
export const NonScrollableBody = createGlobalStyle `body{overflow:hidden;scrollbar-gutter:stable;}`;
export const MainSection = styled.section.withConfig({ displayName: "vui--MainSection", componentId: "vui--1ox4j2c" }) `flex:1;overflow-y:auto;${({ fullBleed }) => !fullBleed && `padding: 0 ${theme.sizes.md};`} ${({ isScrollable }) => isScrollable &&
    `
    & + ${Card.Footer} {
      box-shadow: 0px 10px 15px 0px ${theme.colors.neutral.ink.dark};
    }
  `}`;
//# sourceMappingURL=styled.js.map